module.exports = __webpack_public_path__ + "img/1505234517.c805a498.jpg";